/* Publish by EComposer at 2026-10-28 00:59:30*/
;try{
 
} catch(error){console.error(error);};window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 11px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: rgba(18, 18, 18, 0.75)","background: transparent","opacity: 0.8",""].join(" !important;")),b.innerHTML="Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });